import Sheet from "react-modal-sheet";
import styled from "@emotion/styled";
import React from "react";
import { KeyboardHeight, useKeyboardHeight } from "hooks/useKeyboardHeight";

interface MobileBottomSheetProps {
  title?: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MobileBottomSheet = ({
  children,
  title,
  isOpen,
  setIsOpen,
}: React.PropsWithChildren<MobileBottomSheetProps>) => {
  const close = () => setIsOpen(false);
  const keyboardHeight = useKeyboardHeight();

  return (
    <CustomSheet
      isOpen={isOpen}
      onClose={close}
      detent="content-height"
      initialSnap={0}
      keyboardHeight={keyboardHeight}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
          {title && <Title>{title}</Title>}
          {children}
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={close} />
    </CustomSheet>
  );
};

// Sub-components

const CustomSheet = styled(Sheet)<{
  keyboardHeight: KeyboardHeight;
}>`
  .react-modal-sheet-container {
    background-color: ${props => props.theme.surface.alt.secondary.default}!important;
    width: 95% !important;
    left: 0;
    right: 0;
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 8px;
    transform: ${props =>
      props.keyboardHeight != null ? `translateY(-${props.keyboardHeight}px)` : "none"}!important;
    transition: transform 0.3s linear;
  }

  .react-modal-sheet-header {
    background-color: ${props => props.theme["Dark mode"][800]}!important;
    width: 42px !important;
    height: 4px !important;
    border-radius: 14px;
    margin: 9px auto 10px auto;
  }

  .react-modal-sheet-drag-indicator {
    background-color: ${props => props.theme["Dark mode"][800]}!important;
    width: 42px !important;
    height: 4px !important;
    border-radius: 14px;
  }

  .react-modal-sheet-backdrop {
    background: rgba(0, 0, 0, 0.66);
    backdrop-filter: blur(1.5px);
  }
`;

const Title = styled.h3`
  color: ${props => props.theme.font.primary.default};
  text-align: center;
  font-size: ${props => props.theme.fontSize[6]};
  font-weight: ${props => props.theme.fontWeights["work-sans-0"]};
  line-height: ${props => props.theme.lineHeights[4]};
`;
